export const NEWBUILDING_CARD_SEE_ALL_BUTTON_LINK = 'newbuildingCardSeeAllLink';
